import React from 'react';
import { Box, Divider } from '@mui/material';
import ProfileForm from 'app/form/ProfileForm';
import AddCategoryForm from 'app/form/AddCategoryForm';

const AddCategory = () => {
	return (
		<div>
			<AddCategoryForm />
		</div>
	);
};

export default AddCategory;
